module.exports = __webpack_public_path__ + "img/1F1F8-1F1E6.3d495dd6.svg";